// Measure natural content, never the grid allocation, so cards can shrink too.
const layouts = new WeakMap()

export default {
    mounted(element) {
        const content = element.querySelector('.project-dashboard-widget-content')
        let frame
        const measure = () => {
            cancelAnimationFrame(frame)
            frame = requestAnimationFrame(() => {
                const height = content.getBoundingClientRect().height
                element.style.gridRowEnd = `span ${Math.max(1, Math.ceil(height + 16))}`
            })
        }
        const observer = new ResizeObserver(measure)
        observer.observe(content)
        layouts.set(element, { measure, dispose() {
            observer.disconnect()
            cancelAnimationFrame(frame)
        } })
        measure()
    },
    updated(element) {
        layouts.get(element)?.measure()
    },
    unmounted(element) {
        layouts.get(element)?.dispose()
        layouts.delete(element)
    }
}
